/** Store only diagnostic codes, never messages, response bodies or tokens. */
export function classifyQueueFailure(error, postStarted = false) {
  const response = error?.response;
  const httpStatus = Number.isInteger(response?.status) ? response.status : null;
  let apiCode = null;

  try {
    const { code } = JSON.parse(response?.responseText);
    if (Number.isInteger(code)) apiCode = code;
  } catch {
    // A response body is optional and may not be JSON.
  }

  let kind = 'permanent';

  if (['interaction', 'interaction_required'].includes(error?.kind)) kind = 'interaction';
  else if (error?.kind === 'timeout' || error?.name === 'TimeoutError') kind = 'timeout';
  else if (error?.kind === 'abort' || error?.name === 'AbortError') kind = 'abort';
  else if (error?.kind === 'network' || httpStatus === 0) kind = 'network';
  else if (httpStatus !== null) kind = 'http';
  else if (['captcha', 'environment'].includes(error?.kind)) kind = error.kind;

  const transient =
    ['network', 'timeout'].includes(kind) ||
    (kind === 'http' && (httpStatus === 408 || httpStatus === 429 || (httpStatus >= 500 && httpStatus <= 599)));

  return {
    stage: postStarted ? 'post' : 'preparation',
    kind,
    httpStatus,
    apiCode,
    outcome: postStarted && (!httpStatus || ['network', 'timeout', 'abort'].includes(kind)) ? 'unknown' : 'failed',
    retryable: !postStarted && transient,
  };
}

/**
 * A started POST is never retried. Before the POST, a transient failure leaves the
 * record pending for the next open, online or visibility trigger; others block it.
 */
export function queueFailureChanges(error, { postStarted = false } = {}) {
  const lastError = classifyQueueFailure(error, postStarted);

  return { status: lastError.retryable ? 'pending' : 'blocked', lastError };
}

/** A started POST whose sender stopped before any response was recorded. */
export function interruptedPostFailure() {
  return {
    stage: 'post',
    kind: 'interrupted',
    httpStatus: null,
    apiCode: null,
    outcome: 'unknown',
    retryable: false,
  };
}
